import React from "react";
import { FaStar } from "react-icons/fa";

const items = [
  {
    name: "Rohit Mehta",
    company: "Founder, Delhi D2C Brand",
    text: "Super clear communication and fast GST filing. The WhatsApp updates made it effortless for me."
  },
  {
    name: "Neha Kapoor",
    company: "Salaried Professional, Noida",
    text: "ITR filing was smooth. They explained deductions in simple terms and handled everything on time."
  },
  {
    name: "Arjun Singh",
    company: "Director, MSME Manufacturing",
    text: "ROC compliances and bookkeeping are finally structured. Transparent pricing and reliable support."
  },
  {
    name: "Priya Iyer",
    company: "Co-founder, SaaS Startup",
    text: "Quick checklist, fast turnaround, and very professional. Ideal for startups that need clean compliance."
  }
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="section bg-navy-50/70">
      <div className="mx-auto max-w-7xl container-pad">
        <h2 className="section-title">What Our Clients Say</h2>
        <p className="section-subtitle">
          Google-review style feedback from real Indian clients—focused on clarity, timelines, and trust.
        </p>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {items.map((t) => (
            <div key={t.name} className="card p-6">
              <div className="flex items-center gap-1 text-gold-500">
                {[...Array(5)].map((_, i) => (
                  <FaStar key={i} size={14} />
                ))}
              </div>
              <p className="mt-4 text-sm text-navy-800/80">“{t.text}”</p>
              <div className="mt-5">
                <div className="font-heading text-base text-navy-900">{t.name}</div>
                <div className="text-xs text-navy-800/70">{t.company}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 rounded-2xl border border-navy-900/10 bg-white p-6">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div>
              <div className="font-heading text-xl text-navy-900">Want results like these?</div>
              <div className="text-sm text-navy-800/75">Book a free consultation and get a clear action plan.</div>
            </div>
            <a href="#contact" className="btn-primary">Book Free Consultation</a>
          </div>
        </div>
      </div>
    </section>
  );
}
